<template>
  <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="machineModel"
    :saveMethod="saveMethod">
    <template v-slot:header="{ editMode, setEditMode }">
      <div></div>
      <v-btn icon small @click="setEditMode(!editMode)" style="position: absolute; z-index: 30; right: 8px; top: 8px;">
        <v-icon v-text="editMode ? 'mdi-close' : 'mdi-pencil'"></v-icon>
      </v-btn>
    </template>
    <template v-slot:content="{ item, editMode, edittrigger, handleFocus }">
      <MachineModelEditContent :item="item" :editMode="editMode" :edittrigger="edittrigger" :handleFocus="handleFocus"
        class="pr-6">
      </MachineModelEditContent>
    </template>
  </EntityEditCard>
</template>


<script>
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";
import MachineModelEditContent from "./MachineModelEditContent.vue";

export default {
  name: "MachineModelDetails",
  props: {
    machineModel: Object,
    saveMethod: Function,
  },
  components: {
    EntityEditCard,
    MachineModelEditContent,
  },
  mixins: [],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>